export default __webpack_public_path__ + "static/media/SWT0290.34I-20313_-14780_0.c1fc3733.jpg";